/**
 * Built-in component registry for MarkdownWithComponents.
 *
 * Maps `ui:` block names to their React components.
 * Consumers can extend this via the `components` prop on MarkdownWithComponents.
 */

import MarkdownConfirm from './markdownConfirm'
import type { MarkdownComponentMap } from '../types'

export const builtInComponents: MarkdownComponentMap = {
  confirm: MarkdownConfirm,
}

export { MarkdownConfirm }
